import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qty-stepper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["min", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-sm btn-outline-secondary",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change(-1))),
      disabled: _ctx.modelValue <= _ctx.min
    }, "−", 8, _hoisted_2),
    _createElementVNode("input", {
      type: "number",
      class: "qty-stepper__input",
      min: _ctx.min,
      value: _ctx.modelValue,
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, _hoisted_3),
    _createElementVNode("button", {
      class: "btn btn-sm btn-outline-secondary",
      type: "button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.change(1)))
    }, "+")
  ]))
}